import { View, Model } from 'backbone';
import template from 'dashboard/connections/details/action-rest-web-services.ejs';
import * as gridModels from '../action-type/ActionGridModels';
import constants from 'Constants';
import RestService from 'RestService';
import xJService from 'xml/XJService';
import NotificationService from 'NotificationService.js';
import FormLoadService from 'FormLoadService';
import _ from 'lodash';
import ActionWebServices from './ActionWebServices';
import AutocompleteWebserviceModalView from 'dashboard/connections/details/AutocompleteWebserviceModalView.js';
import sequenceService from 'SequenceService';
import util from 'util/Util.js';

class ActionRestWebServices extends ActionWebServices {
    initialize(opts) {

        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            'change select[name=_responseType]': 'changeReturnTable',
            'change select[name=_requestType]': 'setRequestType',
            "click button[name=addSend], button[name=addReturn]": "itemNew",
            "click button[name=removeSend], button[name=removeReturn]": "itemRemove",
            "click button[name=upSend], button[name=upReturn]": "itemUp",
            "click button[name=downSend], button[name=downReturn]": "itemDown",
            "click button[name=autoSend], button[name=autoReturn]": "autoComplete",
            'focusout input[name=_actionEndpoint]': 'setEndPoint',
            'change input[name=_additionalContentType]': 'setAdditionalContentType',
            'change input[name=_formDataName]': 'setFormDataName'
        };

        this.model.set('operations', [], { silent: true });
        
        if(!this.model.get("currentActionDetails").ActionXML.Action["_actionEndpoint"]){
            this.model.get("currentActionDetails").ActionXML.Action["_actionEndpoint"] = "";
        }

        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    isBinaryOrRaw(value){
        return value === "binary" || value === "raw";
    }

    clearSendGrid(){
        $(constants.CONNECTION_REST_RETURN_CONTAINER).jqGrid('clearGridData');
        this.model.get("currentActionDetails").ActionXML.Action.Receive.Parameter = [];
    }

    setRequestType(ev){
        

        
        return this.actionService.changeActionProperty.apply(this.actionService, arguments);
    }

    changeReturnTable(ev){
       
        if(this.isBinaryOrRaw(ev.currentTarget.value)){            
            this.clearSendGrid();
        }
        else{
            const previousValue = this.model.get('currentActionDetails').ActionXML.Action[ev.currentTarget.name];

            if(this.isBinaryOrRaw(previousValue)){
                this.clearSendGrid();
            }
        }
        return this.actionService.changeActionProperty.apply(this.actionService, arguments);
    }

    getConnection(){
        const connectionId = this.model.get("connectionId");
        RestService.getConnectionDetails(connectionId).then((connectionDetails) => {
            let connectionXML = FormLoadService._decompressForm(connectionDetails.ConnectionXML['#cdata-section']);
            const connectionObject = xJService.toJSON(connectionXML);
            this.serviceURL = connectionObject.Connection._url || "";
            this.setFullURL();
        });
    }


    hasBrackets(value){
        const regExBrackets = /\{\[(.*?)\}\]/g;
        const params = value.match(regExBrackets) || [];
        return params;
    }

    getSendParameters(){
        const gridData = $(constants.CONNECTION_REST_SEND_CONTAINER).jqGrid('getGridParam','data');
        let sendParamsInPath = [];
        
        if(gridData){
            sendParamsInPath = gridData.filter((row) => { return row._placement === "path" || row._placement === "pathbody"; });
        }
        
        let sendParams = "";

        _.each(sendParamsInPath, (param) => {
            sendParams += param._path + "/";            
        });

        return sendParams;
    }

    getQueryStringParams(){
        const gridData = $(constants.CONNECTION_REST_SEND_CONTAINER).jqGrid('getGridParam','data');
        let queryStrings = [];
        
        if(gridData){
            queryStrings = gridData.filter((row) => { return row._placement === "querystring" });
        }
        
        let queryString = "", params = [];
        if(queryStrings && queryStrings.length > 0){
            queryString = "?";

            _.each(queryStrings, (param) => {
                params.push(param._value + "={value}");            
            });

            queryString += params.join("&");
        }

        return queryString;
    }
    
    setEndPoint(ev) {
        this.model.get("currentActionDetails").ActionXML.Action["_actionEndpoint"] = $("#actionEndpoint").val();
        this.setFullURL();

        return this.actionService.changeMethodDetails.apply(this.actionService, arguments);
    }

    setFormDataName(ev){
        let _formDataName = ev.target.value;
        this.model.get("currentActionDetails").ActionXML.Action["_formDataName"] = _formDataName;
        return this.actionService.changeMethodDetails.apply(this.actionService, arguments);
    }

    setAdditionalContentType(ev) {
        let _additionalContentType = ev.target.value;

        this.model.get("currentActionDetails").ActionXML.Action["_additionalContentType"] = _additionalContentType;

        return this.actionService.changeMethodDetails.apply(this.actionService, arguments);
    }

    setFullRequestType(){
        const _additionalContentType = this.model.get("currentActionDetails").ActionXML.Action["_additionalContentType"];
        const _requestType = this.model.get("currentActionDetails").ActionXML.Action['_requestType'];
        let contentTypeFromRequestType = constants.REQUEST_TYPE_CONTENT_TYPE_MAPPING.filter((item)=>{
            return item.requestType === _requestType;
        })[0];

        let fullRequestType = contentTypeFromRequestType ? contentTypeFromRequestType.contentType : '';

        if (_additionalContentType){
            fullRequestType += (fullRequestType ? '; ' : '') + _additionalContentType;
        }

        $("#fullRequestType").val(fullRequestType);
    }

    setLastSlash(value){

        let newValue = value;
        if(value && value.length && value.charAt(value.length - 1) !== "/"){
            newValue += "/";
        }

        return newValue;
    }

    setFullURL(){
        const endpoint = this.model.get("currentActionDetails").ActionXML.Action["_actionEndpoint"];
        const params = this.getSendParameters();
        const queryString = this.getQueryStringParams();
        let fullURL = this.setLastSlash(this.serviceURL) + this.setLastSlash(endpoint) + this.setLastSlash(params); 
        
        if(queryString !== ""){
            if(fullURL.charAt(fullURL.length - 1) === "/"){
                fullURL = fullURL.slice(0,-1);
                fullURL += this.setLastSlash(queryString);
            }
        }

        $("#serviceFullURL").val(fullURL);
    }

    isValidURL(value){
        let expression = /[-a-zA-Z0-9:%_.?&//=]*/gi;
        let regex = new RegExp(expression);
        
        return regex.test(value);
    }

    getSelectedRow(myGrid) {
        const 
            selRowId = parseInt($(myGrid).jqGrid('getGridParam', 'selrow')),
            rowData = $(myGrid).jqGrid("getRowData", selRowId);

        return rowData;
    }

    isSendTable(gridName){
       return gridName.indexOf('Send') > 0;
    }

    itemNew(ev) {
      
        super.itemNew(arguments[0]);

        if(this.isSendTable(ev.currentTarget.name)){
            this.setFullURL();            
        }        
    }

    itemRemove(ev) {
        super.itemRemove(arguments[0]);
        
        if(this.isSendTable(ev.currentTarget.name)){     
            this.setFullURL();
        }        
    }

    itemUp(ev) {

        super.itemUp(arguments[0]);

        if(this.isSendTable(ev.currentTarget.name)){
            this.setFullURL();
        }
    }

    itemDown(ev) {

        super.itemDown(arguments[0]);

        if(this.isSendTable(ev.currentTarget.name)){
            this.setFullURL();
        }
    }

    autoComplete(ev) {

        const isSend = ev.currentTarget.name.indexOf('Send') >= 0;
        let type = "XML";
       
        if(isSend){
            type = $('select[name=_requestType] option:selected').text();
        }
        else{
            type = $('select[name=_responseType] option:selected').text();
        }
      
        const advancedModal = new AutocompleteWebserviceModalView({
            model: new Model(this.model.get('currentActionDetails')), 
            title: `Auto Complete - Rest Web Services ${isSend ? "Send" : "Return"} Parameters`, 
            text: `Enter a Rest Web Service sample response ${type} (complete ${type}):`,
            type: type.toLowerCase(),
            isSend: isSend
        });

        advancedModal.render().then(paths => {
            if (paths) {

                const
                    currentModel = this.model.get('currentActionDetails'),
                    currentModelItems = [];

                paths.forEach((p) => {


                    const value = p,
                        name = p.replace('@', ' - ');
                    const newRow = {
                        '_fixedValue': '',
                        '_id': sequenceService.nextDomId(),
                        '_isFixed': 'false',
                        '_name': name,
                        '_operation': -1,
                        '_value': value,
                        '_isNew': true
                    };

                        if(isSend){
                            newRow['_path'] = value;
                            newRow['_placement'] = "body";
                            newRow['_dataType'] = "System.String";
                            newRow['_isNullable'] = 'false';
                        }
                    currentModelItems.push(newRow);
                });

                if(isSend){
                    currentModel.ActionXML.Action.Send.Parameter = currentModelItems;
                }
                else{
                    currentModel.ActionXML.Action.Receive.Parameter = currentModelItems;
                }
                this.model.set('currentActionDetails', currentModel, {silent: true});
                this.model.set('hasChanges', true);
            }
        });
    }


    validateAndAddCounter(existingParams, value) {

        let newText = value;

        // Normalize names by treating {id} the same as id
        const normalizeName = param => param.replace(/[{}]/g, "");
     
        // Ensure unique and consecutive numbering for full parameters
        const getNextAvailableName = baseName => {
            let maxCounter = -1;
            existingParams.forEach(param => {
                // Check if the parameter is inside a path
                if (param.includes("/")) {
                    const matches = param.match(/\{(.*?)\}/g) || [];
                    matches.forEach(match => {
                        const normalizedParam = normalizeName(match);
                        const numMatch = normalizedParam.match(/(\d+)$/);
                        if (normalizedParam === baseName || numMatch) {
                           
                            const num = numMatch ? parseInt(numMatch[1], 10) : 0;
                            maxCounter = Math.max(maxCounter, num);
                        }
                    });
                } else {
                    const normalizedParam = normalizeName(param);
                    const match = normalizedParam.match(new RegExp(`^${baseName}(\\d+)?(\\[\\])?$`));
                    if (match) {
                        const num = match[1] ? parseInt(match[1], 10) : 0;
                        maxCounter = Math.max(maxCounter, num);
                    }
                }
            });
            return maxCounter === -1 ? baseName : `${baseName}${maxCounter + 1}`;
        };

        // Check if the parameter is inside a path and update only inside {}
        newText = value.replace(/\{(.*?)\}/g, (match, paramName) => {
            let baseName = normalizeName(paramName).replace(/\d+$/, "");
            return `{${getNextAvailableName(baseName)}}`;
        });

        // // Ensure standalone parameters match placeholders inside paths
        let baseName = normalizeName(value).replace(/\d+$/, "");
       
        if (!value.includes("{")) {
            let isArray = baseName.endsWith("[]");
            if (isArray) baseName = baseName.slice(0, -2);
            newText = getNextAvailableName(baseName);
            if (isArray) newText += "[]";
        }

        return newText;
    }


    afterSaveCell(rowId, cellName, value, iRow, iCol, currentView){
        
        let newValue = value;
            
        if(cellName === "_path"){

            let hasError = false;

            // Check if the parameter contains curly brackets
            const hasCurlyBrackets = /\{.*?\}/.test(value);

            
            // Validate balanced {} and [] brackets
            const curlyBracketsMatch = (value.match(/\{/g) || []).length === (value.match(/\}/g) || []).length;
            const squareBracketsMatch = (value.match(/\[/g) || []).length === (value.match(/\]/g) || []).length;
            const curlyBracketsPlaceholders = value.match(/\{(.*?)\}/g) || []; // Ensure only one unique placeholder {}
 
            if (!curlyBracketsMatch || !squareBracketsMatch || (hasCurlyBrackets && curlyBracketsPlaceholders.length > 1)){
                NotificationService.error("The parameter " + value + " does not have the correct format.");
                hasError = true;
            }

            if (!hasError) {

                const currentModelItems = currentView.model.get("currentActionDetails").ActionXML.Action.Send.Parameter;
                const item = currentModelItems[rowId];

                const mydata = $(constants.CONNECTION_REST_SEND_CONTAINER).jqGrid("getGridParam", "data"),
                allParams = $.map(mydata, function (item) { return item._path; });
                allParams.splice(rowId, 1);
                
                newValue = currentView.validateAndAddCounter(allParams, newValue) || newValue;

                item._path = newValue;

                if(hasCurlyBrackets){
                    let match = newValue.match(/\{([^}]+)\}/);
                    newValue = match ? match[1] : item._value;
                }

                item._value = newValue;

                if (util.isTrue(item._isNew)) {

                    
                    item._name = newValue.replace(/[\{\}]/g, '');
                    item._isNew = false;
                }
                
            }     
        }
        super.afterSaveCell(rowId, cellName, newValue, iRow, iCol, currentView);
        currentView.setFullURL();          
    }


    afterEditCell(){}


    renderParametersGrid() {
        let currentModel = this.model.get('currentActionDetails');
        
        const sendItemsToRender = currentModel.ActionXML.Action.Send.Parameter instanceof Array
        ? currentModel.ActionXML.Action.Send.Parameter
            : [currentModel.ActionXML.Action.Send.Parameter];

        const returnItemsToRender = currentModel.ActionXML.Action.Receive.Parameter instanceof Array
         ? currentModel.ActionXML.Action.Receive.Parameter
         : [currentModel.ActionXML.Action.Receive.Parameter];
        
        this.renderParameters(sendItemsToRender, "propSendREST", "Send Parameters",  gridModels.GRID_PARAMETERS_MODEL_REST, gridModels.GRID_REST_SERVICES_PARAMETER_HEADERS, "#sendParams")
        this.renderParameters(returnItemsToRender, "propReturnREST", "Return Parameters", gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION, gridModels.GRID_WEB_SERVICES_PARAMETER_HEADERS, "#returnParams")
        
        $(constants.CONNECTION_REST_RETURN_CONTAINER).setColProp("_name",{editable:true});
        $(constants.CONNECTION_REST_RETURN_CONTAINER).setColProp("_value",{editable:true});

        this.resizeGrid();
    }

    setSelectValues(name){
        const selection = this.model.get('currentActionDetails').ActionXML.Action[name];
        let hideActions = false;

        if(selection && selection !== ""){
            $(`select[name=${name}]`).val(selection);

            if(this.isBinaryOrRaw(selection)){
                hideActions = true;
            }
            
            //Hide autocomplete
            let autoName = name.indexOf("request") >= 0 ? "autoSend" : "autoReturn";
            if(selection !== "xml" && selection !== "json"){
                $(`button[name=${autoName}]`).hide();
            }
            else{
                $(`button[name=${autoName}]`).show();
            }
        }
        else{
            this.model.get('currentActionDetails').ActionXML.Action[name] = $(`select[name=${name}]`).val();
        }       

        return hideActions;
    }

    setRequestValidation(name){
        const selection = this.model.get('currentActionDetails').ActionXML.Action[name];
        let hideDataType = false;

        if(selection && selection !== ""){
            $(`select[name=${name}]`).val(selection);
            
            if (selection === "json") {
                $(constants.CONNECTION_REST_SEND_CONTAINER).setColProp("_dataType", {
                    editoptions: {
                        value: "System.String:String;System.Int32:Integer;System.Boolean:Boolean;System.Byte:File;null:Null"
                    }
                });
            }            
        }
        else{
            this.model.get('currentActionDetails').ActionXML.Action[name] = $(`select[name=${name}]`).val();
        }       

        return hideDataType;
    }

    showFormName(){
        const sendParams = this.model.get('currentActionDetails').ActionXML.Action.Send.Parameter;
        const selection = this.model.get('currentActionDetails').ActionXML.Action['_requestType'];
        let showFormName = false;
        
        const hasStringBodyParameter = (sendParams) => {
            if (!Array.isArray(sendParams)) {
                return false;
            }
    
            return sendParams.some(param => {
                const isCorrectPlacement = param._placement === 'body' || param._placement === 'pathbody';
                const isCorrectDataType = param._dataType === 'System.String';
            
                return isCorrectPlacement && isCorrectDataType;
            });
        }

        if (selection !== 'raw' && selection !== 'none') {
            showFormName = hasStringBodyParameter(sendParams);
        }

        this.model.set('showFormName', showFormName, { silent: true });
    }    
    

    render() {
        this.showFormName();
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.renderParametersGrid();
        
        const response = this.setSelectValues("_responseType");
        this.setSelectValues("_requestType");

        this.setRequestValidation("_requestType");       

        // Hide only if response is raw or binary
        if(response){
            $("#returnParamsActions").hide();
            $(constants.CONNECTION_REST_RETURN_CONTAINER).setColProp("_name",{editable:false});
            $(constants.CONNECTION_REST_RETURN_CONTAINER).setColProp("_value",{editable:false});
        }
        else{
            $("#returnParamsActions").show();
            $(constants.CONNECTION_REST_RETURN_CONTAINER).setColProp("_name",{editable:true});
            $(constants.CONNECTION_REST_RETURN_CONTAINER).setColProp("_value",{editable:true});
        }

        this.relocateServiceDetails();

        if(this.serviceURL === undefined){
            this.getConnection();
        }

        this.setFullRequestType();
        
        this.delegateEvents();
        return this;
    }

}

export default ActionRestWebServices;